import { useQuery } from "@tanstack/react-query";

import { useAuth, axios, authorizedAxios } from "@moonscape/shared";

export const useMessagesData = ({
  page,
  seen,
  // isSearching,
  // searchedValue,
  onLoading,
}) => {
  const { getToken, user } = useAuth();

  // userId
  const email = user?.email;

  console.log("[cc] email", email);

  console.log("useMessagesData-page", page);

  const getMessagesData = async () => {
    try {
      const token = await getToken();

      let url = `/notification/?cursor=${page}&limit=20`;

      if (typeof seen === "boolean") {
        url = `${url}&?seen=${seen}`;
      }

      console.log("tax events url: ", url);
      const res = await authorizedAxios(token).get(
        // TODO: add filter here for exchange and asset
        url
      );
      console.log("useMessagesData() url ", url);

      console.log("[useMessagesData] res", res.data, user?.email);
      return res.data;
    } catch (error) {
      console.log("[useMessagesData] error ", JSON.stringify(error, null, 2));
      return { error };
      // throw error;
    }
  };

  const useQueryKey = `message-${seen}`;

  const {
    isLoading: isQueryLoading,
    isSuccess,
    isIdle,
    error,
    isError,
    data: messages,
    isPreviousData,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: [useQueryKey, page],
    queryFn: getMessagesData,

    // The query will not execute until the userId exists
    enabled: !!email,

    keepPreviousData: true,
    refetchOnWindowFocus: true,
  });
  // isSearching && isFetching ? onLoading(isFetching) : onLoading(false);

  return { isQueryLoading, isIdle, error, messages, isPreviousData, refetch };
};
